import React from "react";
// import ButtonPrimary from "shared/Button/ButtonPrimary";
import CommonLayout from "./CommonLayout";

const AccountBilling = () => {
  return (
    <div>
      <CommonLayout>
        <div className="space-y-6 sm:space-y-8">
          {/* HEADING */}
          <h2 className="text-3xl font-semibold">Verifikasi</h2>
          <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
            <h3 className="text-xl">Nothing to see here 👀</h3>
        </div>
      </CommonLayout>
    </div>
  );
};

export default AccountBilling;
